import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '@/routes/common/ProtectedRoute';
import { SuspenseWrapper } from '@/routes/common/SuspenseWrapper';

const FamilyUserList = lazy(() => import('@/pages/family-user/List.tsx'));
const FamilyUserDetail = lazy(() => import('@/pages/family-user/Detail.tsx'));
const FamilyUserCreate = lazy(() => import('@/pages/family-user/Create.tsx'));
const FamilyUserEdit = lazy(() => import('@/pages/family-user/Edit.tsx'));

export const familyMemberRoutes: RouteObject = {
  path: 'family-users',
  children: [
    {
      path: 'list',
      element: (
        <ProtectedRoute pageKey="page:family-users:list">
          <SuspenseWrapper>
            <FamilyUserList />
          </SuspenseWrapper>
        </ProtectedRoute>
      ),
    },
    {
      path: 'detail/:uuid',
      element: (
        <ProtectedRoute pageKey="page:family-users:detail">
          <SuspenseWrapper>
            <FamilyUserDetail />
          </SuspenseWrapper>
        </ProtectedRoute>
      ),
    },
    {
      path: 'create',
      element: (
        <ProtectedRoute pageKey="page:family-users:create">
          <SuspenseWrapper>
            <FamilyUserCreate />
          </SuspenseWrapper>
        </ProtectedRoute>
      ),
    },
    {
      path: 'edit/:uuid',
      element: (
        <ProtectedRoute pageKey="page:family-users:edit">
          <SuspenseWrapper>
            <FamilyUserEdit />
          </SuspenseWrapper>
        </ProtectedRoute>
      ),
    },
  ],
};
